import React from 'react';
import Emoji from './../Partials/Emoji';

const CommentDummy = (props) => (
    <div className="comment comment--dummy">
        <Emoji type="avatar" className="comment__avatar comment__avatar--svg rounded-circle" />
        <div className="comment__body">
        </div>
        { props.children &&
            <div className="comment__replies">
                { props.children }
            </div>
        }
    </div>
);

export default CommentDummy;